/**
 * Status values (canonical strings shared across Webapp / Document-Export / Editor).
 */
export const PdfExportStatusValue = {
    Queued: 'QUEUED',
    InProgress: 'IN_PROGRESS',
    Succeeded: 'SUCCEEDED',
    Failed: 'FAILED',
    Skipped: 'SKIPPED',
} as const;

export type PdfExportStatusValue =
    (typeof PdfExportStatusValue)[keyof typeof PdfExportStatusValue];

export const PDF_EXPORT_STATUS_OPTIONS: { value: PdfExportStatusValue; label: string }[] = [
    { value: 'QUEUED', label: 'Queued' },
    { value: 'IN_PROGRESS', label: 'In progress' },
    { value: 'SUCCEEDED', label: 'Succeeded' },
    { value: 'FAILED', label: 'Failed' },
    { value: 'SKIPPED', label: 'Skipped' },
];

export const PDF_EXPORT_TRIGGER_OPTIONS: { value: string; label: string }[] = [
    { value: 'publish', label: 'Publish' },
    { value: 'manual-retry', label: 'Manual retry' },
];

export interface PdfExport {
    id: string;
    accountId: string | null;
    documentId: string | null;
    documentVersionId: string | null;
    topicVersionId: string | null;
    publishId: string;
    languageCode: string;
    status: string;
    trigger: string;
    triggeredBy: string | null;
    queuedAt: string | null;
    startedAt: string | null;
    finishedAt: string | null;
    durationMs: number | null;
    errorMessage: string | null;
    errorCode: string | null;
    pdfGcsPath: string | null;
    pdfSizeBytes: number | null;
    attemptCount: number;
    schemaVersion: number;
}

export interface PdfExportListResponse {
    items: PdfExport[];
    nextCursorQueuedAtTicks: number | null;
}

export interface PdfExportFilters {
    statuses: PdfExportStatusValue[];
    from: string | null;
    to: string | null;
    accountId: string | null;
    documentId: string | null;
    trigger: string | null;
}
